import { css } from 'emotion'

export const marginBottomLargeStyles = css`
  margin-bottom: 32px;
`
